// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.revico-community-talk-details-new-arrival-badge[data-v-3d2cb382] {\r\n\tposition: absolute;\r\n\ttop: 8px;\r\n\tright: 0px;\r\n\tcolor: #f44336;\r\n\tfont-weight: bold;\r\n\tpadding: 0 4px 0 5px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #f44336;\r\n\tborder-radius: 12px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
